export const START_BEFORE_TODAY = 'START_BEFORE_TODAY';
export const END_BEFORE_TODAY = 'END_BEFORE_TODAY';
export const END_BEFORE_START = 'END_BEFORE_START';
export const START_REQUIRED = 'START_REQUIRED';
export const END_REQUIRED = 'END_REQUIRED';

export const LICENSE_VALIDATIONS = {
    [START_BEFORE_TODAY]: 'License start date cannot be earlier than yesterday',
    [END_BEFORE_TODAY]: 'License end date cannot be earlier than today',
    [END_BEFORE_START]: 'License end date cannot be before the start date',
    [START_REQUIRED]: 'License start date field is required',
    [END_REQUIRED]: 'License end date field is required',
};

type GetEndDateErrorsProps = {
    isToday: (date: string) => boolean,
    isFutureDate: (date?: string) => boolean,
    isAfterDate: (date1: string, date2: string) => boolean,
    startDate?: string,
    endDate?: string,
    validateEmpty?: boolean,
};
export const getEndDateErrors = ({
    startDate,
    endDate,
    validateEmpty,
    isToday,
    isFutureDate,
    isAfterDate,
}: GetEndDateErrorsProps) => {
    if (!endDate && validateEmpty) {
        return {code: END_REQUIRED, message: LICENSE_VALIDATIONS[END_REQUIRED]};
    }

    if (endDate && !isFutureDate(endDate) && !isToday(endDate)) {
        return {code: END_BEFORE_TODAY, message: LICENSE_VALIDATIONS[END_BEFORE_TODAY]};
    }

    if (endDate && !startDate && !isFutureDate(endDate) && !isToday(endDate)) {
        return {code: END_BEFORE_TODAY, message: LICENSE_VALIDATIONS[END_BEFORE_TODAY]};
    }

    if (startDate && endDate && isAfterDate(startDate, endDate) && startDate !== endDate) {
        return {code: END_BEFORE_START, message: LICENSE_VALIDATIONS[END_BEFORE_START]};
    }

    if (endDate && startDate && !(isAfterDate(endDate, startDate) || isToday(endDate))) {
        return {code: END_BEFORE_START, message: LICENSE_VALIDATIONS[END_BEFORE_START]};
    }

    return null;
};

type GetStartDateErrorsProps = {startDate?: string, validateEmpty?: boolean};
export const getStartDateErrors = ({startDate, validateEmpty}: GetStartDateErrorsProps) => {
    if (!startDate && validateEmpty) {
        return {code: START_REQUIRED, message: LICENSE_VALIDATIONS[START_REQUIRED]};
    }
    return null;
};
